export default __webpack_public_path__ + "static/media/trophy.994f1b1a.svg";